import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Parecer {
  id?: number;
  descricao: string;
  tipo: 'DESCRITIVO' | 'CONCEITO';
  parecer?: string;
  competencias?: Competencia[];
  conhecimentos?: Conhecimento[];
  habilidades?: Habilidade[];
  atitudes?: Atitude[];
}

export interface Competencia {
  id: number;
  descricao: string;
  nivel: number;
}

export interface Conhecimento {
  id: number;
  descricao: string;
  nivel: number;
}

export interface Habilidade {
  id: number;
  descricao: string;
  nivel: number;
}

export interface Atitude {
  id: number;
  descricao: string;
  nivel: number;
}

export interface ChaData {
  competencias: Competencia[];
  conhecimentos: Conhecimento[];
  habilidades: Habilidade[];
  atitudes: Atitude[];
}

@Injectable({
  providedIn: 'root'
})
export class ParecerService {

  constructor(private http: HttpClient) { }

  getParecerDetalhado(registroAvaliacaoId: number): Observable<Parecer> {
    return this.http.get<Parecer>(`/api/commons/avaliacoes/${registroAvaliacaoId}`);
  }

  salvarParecer(turmaId: number, parecer: Parecer): Observable<Parecer> {
    const url = `/api/commons/turma/${turmaId}/avaliacoes/parecer`;
    if (parecer.id) {
      return this.http.put<Parecer>(`${url}/${parecer.id}`, parecer);
    } else {
      return this.http.post<Parecer>(url, parecer);
    }
  }

  salvarCha(registroAvaliacaoId: number, chaData: Partial<ChaData>): Observable<ChaData> {
    return this.http.put<ChaData>(`/api/commons/avaliacoes/${registroAvaliacaoId}/cha`, chaData);
  }
}